import { useEffect } from 'react';
import ResizeObserverPolyfill from 'resize-observer-polyfill';

import { useFreshRef } from './useFreshRef';

/**
 * Hook that observes resize changes on a DOM element
 * @param element The DOM element to observe for resize changes
 * @param onResize Callback function called when resize is detected
 */
export const useResizeObserver = (
  element: HTMLElement | null,
  onResize: (element: HTMLElement) => void
): void => {
  const refOnResize = useFreshRef<(element: HTMLElement) => void>(onResize);

  useEffect(() => {
    if (!element) {
      return undefined;
    }

    const resizeObserver = new ResizeObserverPolyfill(() => {
      if (element && refOnResize.current) {
        refOnResize.current(element);
      }
    });
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [element, refOnResize]);
};
